import * as React from "react";
import { ForwardedRef as ReactForwardedRef } from "react";

declare module "react" {
  export function forwardRef<T, P = {}>(
    render: (props: P, ref: ReactForwardedRef<T>) => React.ReactElement | null,
  ): (props: P & React.RefAttributes<T>) => React.ReactElement | null;
}
